// extracted by mini-css-extract-plugin
module.exports = {"div":"start-module--div--1nONO","h1":"start-module--h1--3HnLi","p":"start-module--p--M9QaN","para":"start-module--para--5F9js"};